import React, { useState } from "react";
import "../CSS/AgentLogin.css";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import logo from "../../assets/icone.png";

const Employer_log_in = () => {
  const [formData, setFormData] = useState({
    name: "",
    agentPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const handleNavigation = (destination) => {
      const username = Cookies.get("userID");
  

      navigate(`/${destination}`);
    };
  

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Agent name is required.";
    }

    if (!formData.agentPassword.trim()) {
      newErrors.agentPassword = "Agent password is required.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {


        const response = await fetch(
          "https://advenwarecareerlink.com/acl/Organizations/Regester_organization.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message);
        }

        if(result.message == 'available')
        {
          alert("Agent login successful!");
              const login = () => {
                    Cookies.set("organization_name", `${formData.name}`, {
                      expires: 7 * 42
                   });
          
                  
                 };
          
                 login()

                 handleNavigation('employer')
        }

        else{
             alert("Unable to sign in. Please check your credentials or create an Agent Account");
        }


      console.log("Agent login:", formData);

      await new Promise((resolve) =>
        setTimeout(resolve, 1200)
      );

      

    } catch (error) {
      console.error(error);
      alert("Unable to sign in. Check your network");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="agent-login-page">

      {/* ==================================================
          LEFT SIDE
      ================================================== */}

      <section className="agent-login-hero">

        <div className="agent-background-grid"></div>

        <div className="agent-hero-content">

          {/* BRAND */}

          <div className="agent-brand">

              <img
                src={logo}
                alt="Advenware Career Link"
                className="landing-logo-image"
              />

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>

          </div>


          {/* HERO CONTENT */}

          <div className="agent-hero-message">

            <div className="agent-badge">
              ORGANISATION PORTAL
            </div>

            <h1>
              Connect.
              <span> Discover. </span>
              Place.
            </h1>

            <p>
              Welcome to the Advenware orrganisation portal.
              Sign in to manage student and organization
              connections and help create meaningful
              attachment opportunities.
            </p>


            {/* AGENT FEATURES */}

            <div className="agent-features">

              <div className="agent-feature">

                <div className="agent-feature-icon">
                  ✓
                </div>

                <div>
                  <strong>
                    Discover Talents
                  </strong>

                  <span>
                    Find the right talents for your organization.
                  </span>
                </div>

              </div>


              <div className="agent-feature">

                <div className="agent-feature-icon">
                  ✓
                </div>

                <div>
                  <strong>
                    Looking for the right talent?
                  </strong>

                  <span>
                    We'll help you find one.
                  </span>
                </div>

              </div>


              <div className="agent-feature">

                <div className="agent-feature-icon">
                  ✓
                </div>

                <div>
                  <strong>
                    Manage your Organisation activities
                  </strong>

                  <span>
                    Keep track of your work through the Orgainzation portal.
                  </span>
                </div>

              </div>

            </div>

          </div>


          <div className="agent-hero-footer">

            <span>
              © 2026 Advenware Careere Link
            </span>

            <span>
              Field Operations • Students • Organizations
            </span>

          </div>

        </div>

      </section>


      {/* ==================================================
          RIGHT SIDE
      ================================================== */}

      <section className="agent-login-area">

        <div className="agent-login-wrapper">

          {/* MOBILE BRAND */}

          <div className="mobile-agent-brand">

            <div className="agent-brand-icon">
              AC
            </div>

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>

          </div>


          {/* HEADER */}

          <div className="agent-login-header">

            <div className="agent-login-label">
              ORGANIZATION ACCESS
            </div>

            <h1>
              Welcome, Partner
            </h1>

            <p>
              Enter your credentials to access the
              Advenware field Orgainzation portal.
            </p>

          </div>


          <form onSubmit={handleSubmit}>

            {/* SYSTEM CODE */}

            <div className="agent-input-group">

              <label>
                Orgainization Name <span>*</span>
              </label>

              <div className="agent-input-container">

                <span className="agent-input-icon">
                  #
                </span>

                <input
                  type="text"
                  name="name"
                  placeholder="Enter Agent Name"
                  value={formData.systemCode}
                  onChange={handleChange}
                  autoComplete="username"
                />

              </div>

              {errors.systemCode && (
                <small className="agent-error">
                  {errors.systemCode}
                </small>
              )}

            </div>


            {/* AGENT PASSWORD */}

            <div className="agent-input-group">

              <label>
                Organization password <span>*</span>
              </label>

              <div className="agent-input-container">

                <span className="agent-input-icon">
                  🔒
                </span>

                <input
                  type={showPassword ? "text" : "password"}
                  name="agentPassword"
                  placeholder="Enter your agent password"
                  value={formData.agentPassword}
                  onChange={handleChange}
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="password-toggle"
                  onClick={() =>
                    setShowPassword((prev) => !prev)
                  }
                  aria-label={
                    showPassword
                      ? "Hide password"
                      : "Show password"
                  }
                >
                  {showPassword ? "Hide" : "Show"}
                </button>

              </div>

              {errors.agentPassword && (
                <small className="agent-error">
                  {errors.agentPassword}
                </small>
              )}

            </div>


            {/* SECURITY CARD */}

            <div className="agent-security-card">

              <div className="agent-security-icon">
                ✓
              </div>

              <div>

                <strong>
                  Authorized Orgainzations only
                </strong>

                <p>
                  This portal is restricted to registered
                  Orgainization. Your activity
                  may be monitored for security purposes.
                </p>

              </div>

            </div>


            {/* LOGIN */}

            <button
              type="submit"
              className="agent-login-button"
              disabled={loading}
            >

              {loading
                ? "Verifying agent..."
                : "Access Organizaton portal →"}

            </button>


            {/* HELP */}

            <div className="agent-help">

              <span>
                Don't have an Organization account??
              </span>

              <button
                type="button"
                  onClick={() =>
                handleNavigation("Organization_account_creation")
              }
              >
                Create An Orgainization Account
              </button>

            </div>


            {/* DIVIDER */}

            <div className="agent-divider">

              <span></span>

              <p>
                ADVENEWARE CAREERE LINK
              </p>

              <span></span>

            </div>


            <p className="agent-footer-note">
              Secure field organisation portal
            </p>

          </form>

        </div>

      </section>

    </div>
  );
};

export default Employer_log_in;